import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Sidebar from "../Misc/Sidebar";
import DashNavbar from "../Misc/DashNavbar";
import { Modal, Pagination, Form } from "react-bootstrap";
import { FaPlus, FaTrashAlt, FaSearch, FaUsers, FaCalendarPlus } from "react-icons/fa";
import { FadeLoader } from "react-spinners";
import Select from "react-select";

// Custom Styles Component (Embedded CSS)
const CustomStyles = () => (
  <style>{`
    body {
      background-color: #f4f7f6;
      font-family: 'Poppins', sans-serif;
    }

    .gradient-text {
      background: linear-gradient(45deg, #007bff, #0056b3);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 600;
    }
    
    .card-custom {
      background-color: #ffffff;
      border-radius: 15px;
      padding: 30px;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.07);
      transition: all 0.3s ease;
    }
    .card-custom:hover {
      box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
    }

    .page-header {
      font-size: 2.25rem;
      margin-bottom: 25px;
      color: #333;
    }

    .search-bar-custom .form-control {
      border-radius: 25px;
      padding-left: 40px;
      border: 1px solid #ced4da;
      transition: border-color 0.3s ease, box-shadow 0.3s ease;
    }
    .search-bar-custom .form-control:focus {
      border-color: #007bff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
    .search-bar-custom .search-icon {
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
      color: #777;
    }
    
    .actions-container {
      margin-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .btn-custom {
      border-radius: 20px;
      padding: 10px 20px;
      font-size: 0.9rem;
      font-weight: 500;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .btn-custom:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    }
    .btn-custom-success { background-color: #28a745; border-color: #28a745; color: white; }
    .btn-custom-success:hover { background-color: #218838; border-color: #1e7e34; color: white; }
    .btn-custom-primary { background-color: #007bff; border-color: #007bff; color: white; }
    .btn-custom-primary:hover { background-color: #0069d9; border-color: #0062cc; color: white; }
    
    .table-custom thead th {
      background-color: #f8f9fa;
      color: #333;
      font-weight: 600;
      border-bottom-width: 2px;
      text-align: left;
    }
    .table-custom tbody tr { transition: background-color 0.2s ease; }
    .table-custom tbody tr:hover { background-color: #e9ecef; }
    .table-custom td, .table-custom th { padding: 12px 15px; vertical-align: middle; }

    .spinner-container-page {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;
    }
    
    .pagination-custom .page-item.active .page-link { background-color: #007bff; border-color: #007bff; color: white; }
    .pagination-custom .page-link { color: #007bff; border-radius: 0.25rem; margin: 0 2px; }
    .pagination-custom .page-link:hover { background-color: #e9ecef; }
    .pagination-custom .page-item.disabled .page-link { color: #6c757d; }

    .modal-custom .modal-header { background: linear-gradient(45deg, #007bff, #0056b3); color: white; border-bottom: none; }
    .modal-custom .modal-header .btn-close { filter: invert(1) grayscale(100%) brightness(200%); }
    .modal-custom .modal-title { font-weight: 500; }
    .modal-custom .modal-body { padding: 25px; }
    .modal-custom .form-label { font-weight: 500; margin-bottom: 0.3rem; color: #555; }
    
    .select__control { border-radius: 8px !important; border: 1px solid #ced4da !important; box-shadow: none !important; }
    .select__control:hover { border-color: #007bff !important; }
    .select__control--is-focused { border-color: #007bff !important; box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important; }
    .select__menu { border-radius: 8px !important; box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important; }
    .select__option:hover { background-color: #007bff !important; color: white !important; }
    .select__option--is-selected { background-color: #0069d9 !important; color: white !important; }

    .interview-schedule-page.wrapper {
      display: flex;
      height: calc(100vh - 60px);
    }

    .interview-schedule-page .main {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding: 20px;
      background-color: #f4f7f6;
    }

    .interview-schedule-page .container-fluid {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }

    .interview-schedule-page .card-custom {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .interview-schedule-page .table-responsive {
      flex-grow: 1;
      overflow-y: auto;
    }
  `}</style>
);

const reactSelectStyles = {
  control: (provided) => ({ ...provided, borderColor: '#ced4da', borderRadius: '8px', boxShadow: 'none', '&:hover': { borderColor: '#007bff' } }),
  menu: (provided) => ({ ...provided, borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }),
  option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? '#0069d9' : state.isFocused ? '#007bff' : 'white', color: state.isSelected || state.isFocused ? 'white' : 'black', '&:active': { backgroundColor: '#0056b3' } }),
};

const getCandidateFullName = (candidate) => {
    if (!candidate) return "";
    return `${candidate.first_name || ''} ${candidate.middle_name || ''} ${candidate.last_name || ''}`.replace(/\s+/g, ' ').trim();
};

export default function InterviewSchedule() {
  const [isLoading, setIsLoading] = useState(false);
  const [applicantData, setApplicantData] = useState([]);
  const [interviewData, setInterviewData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showStudentListModal, setShowStudentListModal] = useState(false);
  const [interviewerOptions, setInterviewerOptions] = useState([]);
  const [formData, setFormData] = useState({
    candidate: "", candidateId: null, interviewer: "", additionalMembers: [], meetLink: "", date: "", time: "",
    jobTitle: "", mode: "Online", location: "", interviewer_contact_number: "", opening_post: ""
  });
  const [openingPostOptions, setOpeningPostOptions] = useState([]);
  const [jobTitleOptions, setJobTitleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [interviewersData, setInterviewersData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredInterviewData, setFilteredInterviewData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [studentPage, setStudentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const studentItemsPerPage = 5;

  const candidateOptions = applicantData
    .sort((a, b) => getCandidateFullName(a).localeCompare(getCandidateFullName(b)))
    .map((candidate) => {
        const fullName = getCandidateFullName(candidate);
        return { value: fullName, label: `${fullName} (ID: ${candidate.id})`, id: candidate.id };
    });

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      try {
        const [applicantRes, interviewsRes, interviewersRes] = await Promise.all([
          axios.get("https://raasbackend.vetrinahealthcare.com/applicants_alt/"),
          axios.get("https://raasbackend.vetrinahealthcare.com/interviews/"),
          axios.get("https://raasbackend.vetrinahealthcare.com/get_interviewers/"),
        ]);

        setApplicantData(applicantRes.data);
        setInterviewData(interviewsRes.data);
        setFilteredInterviewData(interviewsRes.data);
        setInterviewersData(interviewersRes.data);

        const interviewerOpts = interviewersRes.data.map((interviewer) => ({
          value: interviewer.name,
          label: interviewer.name,
        }));
        setInterviewerOptions(interviewerOpts);

      } catch (err) {
        console.error("Error fetching initial data:", err);
        Swal.fire({ icon: "error", title: "Failed to load data", text: "Could not fetch initial data. Please try refreshing the page." });
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllData();
  }, []);

  useEffect(() => {
    if (!showModal) {
      setFormData({
        candidate: "", candidateId: null, interviewer: "", additionalMembers: [], meetLink: "", date: "", time: "",
        jobTitle: "", mode: "Online", location: "", interviewer_contact_number: "", opening_post: ""
      });
      setOpeningPostOptions([]);
      setJobTitleOptions([]);
    }
  }, [showModal]);

  const handleSelectChange = (name, selectedOption) => {
    const newState = { ...formData, [name]: selectedOption ? selectedOption.value : "" };

    switch (name) {
      case "candidate":
        newState.candidateId = selectedOption ? selectedOption.id : null;
        newState.opening_post = "";
        newState.jobTitle = "";
        setJobTitleOptions([]);

        if (selectedOption) {
            const selectedApplicant = applicantData.find(app => app.id === selectedOption.id);
            const applications = selectedApplicant?.action?.personality_results || [];
            const uniquePosts = [...new Set(applications.map(app => app.opening_post).filter(Boolean))];
            setOpeningPostOptions(uniquePosts.map(post => ({ value: post, label: post })));
        } else {
            setOpeningPostOptions([]);
        }
        break;

      case "interviewer":
        if (selectedOption) {
          const selectedInterviewer = interviewersData.find(i => i.name === selectedOption.value);
          // Assuming the contact number field in the API response is 'phone' or 'contact_number'
          newState.interviewer_contact_number = selectedInterviewer?.contact_number || selectedInterviewer?.phone || "";
        } else {
          newState.interviewer_contact_number = "";
        }
        break;

      case "opening_post":
        newState.jobTitle = "";
        if (selectedOption && formData.candidateId) {
            const selectedApplicant = applicantData.find(app => app.id === formData.candidateId);
            const applications = selectedApplicant?.action?.personality_results || [];
            const titles = applications
                .filter(app => app.opening_post === selectedOption.value)
                .map(app => ({ value: app.job_title, label: app.job_title }));
            setJobTitleOptions(titles);
        } else {
          setJobTitleOptions([]);
        }
        break;
      
      default:
        break;
    }

    setFormData(newState);
  };

  const handleFormInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!formData.candidate || !formData.interviewer || !formData.date || !formData.time || !formData.jobTitle || !formData.opening_post) {
        Swal.fire({ icon: "warning", title: "Missing Information", text: "Please fill all required fields.", timer: 3000, timerProgressBar: true, showConfirmButton: false });
        setLoading(false);
        return;
      }

      const selectedInterviewer = interviewersData.find((i) => i.name === formData.interviewer);
      const fullSelectedCandidate = applicantData.find((c) => c.id === formData.candidateId);

      if (!selectedInterviewer || !fullSelectedCandidate) {
        throw new Error("Selected candidate or interviewer details not found.");
      }

      const dataToSend = {
        candidate: getCandidateFullName(fullSelectedCandidate),
        candidateEmail: fullSelectedCandidate.email,
        interviewerEmail: selectedInterviewer.email,
        interviewer: formData.interviewer,
        date: formData.date,
        time: formData.time,
        interviewMode: formData.mode,
        meetingLink: formData.mode === "Online" ? formData.meetLink : "",
        interviewLocation: formData.mode === "Offline" ? formData.location : "",
        jobTitle: formData.jobTitle,
        opening_post: formData.opening_post,
        status: "scheduled",
      };

      await axios.post("https://raasbackend.vetrinahealthcare.com/schedule-interview/", dataToSend);
      const res = await axios.get("https://raasbackend.vetrinahealthcare.com/interviews/");
      setInterviewData(res.data);
      setFilteredInterviewData(res.data);
      setShowModal(false);
      Swal.fire({ icon: "success", title: "Interview Scheduled!", text: "The interview has been scheduled successfully.", timer: 2000, timerProgressBar: true, showConfirmButton: false });
    } catch (error) {
      console.error("Error scheduling interview:", error.response ? error.response.data : error.message);
      Swal.fire({ icon: "error", title: "Oops...", text: (error.response?.data?.error) || "Something went wrong! Please try again later." });
    } finally {
      setLoading(false);
    }
  };

  function formatTime(time) {
    if (!time) return "N/A";
    const [hoursStr, minutesStr] = time.split(":");
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    if (isNaN(hours) || isNaN(minutes)) return "Invalid Time";
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${String(minutes).padStart(2, "0")} ${period}`;
  }

  const toggleStudentListModal = () => setShowStudentListModal(!showStudentListModal);

  useEffect(() => {
    const filtered = interviewData.filter((interview) => {
      const query = searchQuery.toLowerCase();
      return (
        interview.candidate?.toLowerCase().includes(query) ||
        interview.interviewer?.toLowerCase().includes(query) ||
        interview.job_title?.toLowerCase().includes(query) ||
        interview.opening_post?.toLowerCase().includes(query) ||
        (interview.date && new Date(interview.date).toLocaleDateString().toLowerCase().includes(query))
      );
    });
    setFilteredInterviewData(filtered);
    setCurrentPage(1);
  }, [interviewData, searchQuery]);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredInterviewData.slice(indexOfFirstItem, indexOfLastItem);
  const studentIndexOfLastItem = studentPage * studentItemsPerPage;
  const studentIndexOfFirstItem = studentIndexOfLastItem - studentItemsPerPage;
  const currentStudentItems = applicantData.slice(studentIndexOfFirstItem, studentIndexOfLastItem);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const handleStudentPageChange = (pageNumber) => setStudentPage(pageNumber);

  const totalPages = Math.ceil(filteredInterviewData.length / itemsPerPage);
  const totalStudentPages = Math.ceil(applicantData.length / studentItemsPerPage);

  return (
    <>
      <CustomStyles />
      <DashNavbar />
      <div className="wrapper interview-schedule-page">
        <Sidebar />
        <main className="main">
          <div className="container-fluid mt-3">
            <div className="card-custom">
              <h1 className="page-header gradient-text mb-4">Interview Schedule</h1>
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="search-bar-custom position-relative">
                    <FaSearch className="search-icon" />
                    <input type="search" className="form-control" placeholder="Search by candidate, interviewer, job title, or date..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                  </div>
                </div>
                <div className="col-md-6 d-flex justify-content-md-end align-items-center mt-3 mt-md-0">
                  <div className="actions-container">
                    <button className="btn btn-custom btn-custom-success" onClick={() => setShowModal(true)}><FaCalendarPlus /> Schedule Interview</button>
                    <button className="btn btn-custom btn-custom-primary" onClick={toggleStudentListModal}><FaUsers /> View Users</button>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <div className="spinner-container-page"><FadeLoader color="#007bff" loading={isLoading} size={150} /></div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-custom table-hover table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Candidate</th>
                          <th>Candidate ID</th>
                          <th>Interviewer</th>
                          <th>Job Title</th>
                          <th>Opening Post</th>
                          <th>Date</th>
                          <th>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length > 0 ? currentItems.map((interview, index) => (
                          <tr key={interview.id || index}>
                            <td>{indexOfFirstItem + index + 1}</td>
                            <td>{interview.candidate}</td>
                            <td>{interview.candidate_id || "N/A"}</td>
                            <td>{interview.interviewer}</td>
                            <td>{interview.job_title || "N/A"}</td>
                            <td>{interview.opening_post || "N/A"}</td>
                            <td>{interview.date ? new Date(interview.date).toLocaleDateString() : "N/A"}</td>
                            <td>{formatTime(interview.time)}</td>
                          </tr>
                        )) : (
                          <tr><td colSpan="8" className="text-center py-4">No interviews found.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {filteredInterviewData.length > 0 && (
                     <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
                        <div className="d-flex align-items-center">
                            <span className="me-2 small text-muted">Show</span>
                            <Form.Select size="sm" style={{ width: 'auto' }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </Form.Select>
                            <span className="ms-2 small text-muted">entries</span>
                        </div>

                        {totalPages > 1 && (
                            <Pagination className="pagination-custom mb-0">
                                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => handlePageChange(i + 1)}>{i + 1}</Pagination.Item>
                                ))}
                                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                            </Pagination>
                        )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </main>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered dialogClassName="modal-custom" size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            Schedule New Interview
            {loading && <FadeLoader color="#ffffff" loading={loading} css={{ display: 'inline-block', marginLeft: '15px', verticalAlign: 'middle' }} height={20} width={3} radius={2} margin={2} />}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Candidate:</label>
                <Select styles={reactSelectStyles} options={candidateOptions} value={candidateOptions.find(o => o.id === formData.candidateId)} onChange={(val) => handleSelectChange("candidate", val)} placeholder="Select Candidate..." isSearchable={true} isClearable />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Interviewer:</label>
                <Select styles={reactSelectStyles} options={interviewerOptions} value={interviewerOptions.find(o => o.value === formData.interviewer)} onChange={(val) => handleSelectChange("interviewer", val)} placeholder="Select Interviewer..." isSearchable={true} isClearable />
              </div>
            </div>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label">Opening Post:</label>
                    <Select styles={reactSelectStyles} options={openingPostOptions} value={openingPostOptions.find(o => o.value === formData.opening_post)} onChange={(val) => handleSelectChange("opening_post", val)} placeholder="Select Opening Post..." isSearchable={true} isClearable={true} isDisabled={!formData.candidateId} />
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label">Job Title:</label>
                    <Select styles={reactSelectStyles} options={jobTitleOptions} value={jobTitleOptions.find(o => o.value === formData.jobTitle)} onChange={(val) => handleSelectChange("jobTitle", val)} placeholder="Select Job Title..." isSearchable={true} isClearable={true} isDisabled={!formData.opening_post} />
                </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Mode:</label>
                <Select styles={reactSelectStyles} options={[{ value: 'Online', label: 'Online' }, { value: 'Offline', label: 'Offline (In-Person)' }]} value={{ value: formData.mode, label: formData.mode === 'Offline' ? 'Offline (In-Person)' : 'Online' }} onChange={(val) => handleSelectChange("mode", {value: val.value})} />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Interviewer Contact:</label>
                <input type="text" className="form-control" name="interviewer_contact_number" value={formData.interviewer_contact_number} onChange={handleFormInputChange} placeholder="Auto-filled after selecting interviewer" readOnly />
              </div>
            </div>
            {formData.mode === 'Online' ? (
              <div className="mb-3">
                <label className="form-label">Meeting Link:</label>
                <input type="url" className="form-control" name="meetLink" value={formData.meetLink} onChange={handleFormInputChange} placeholder="https://meet.example.com/abc-def-ghi" required />
              </div>
            ) : (
              <div className="mb-3">
                <label className="form-label">Location / Address:</label>
                <input type="text" className="form-control" name="location" value={formData.location} onChange={handleFormInputChange} placeholder="e.g., Office Building, 2nd Floor, City" required />
              </div>
            )}
            
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Date:</label>
                <input type="date" className="form-control" name="date" value={formData.date} onChange={handleFormInputChange} min={new Date().toISOString().split("T")[0]} required/>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Time:</label>
                <input type="time" className="form-control" name="time" value={formData.time} onChange={handleFormInputChange} required/>
              </div>
            </div>
            <div className="d-grid">
              <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
                {loading ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Scheduling...</>) : ("Schedule Interview")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={showStudentListModal} onHide={toggleStudentListModal} centered dialogClassName="modal-custom" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>User List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table table-custom table-hover table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>ID</th>
                </tr>
              </thead>
              <tbody>
                {currentStudentItems.length > 0 ? currentStudentItems.map((applicant, index) => (
                  <tr key={applicant.id || index}>
                    <td>{studentIndexOfFirstItem + index + 1}</td>
                    <td>{getCandidateFullName(applicant)}</td>
                    <td>{applicant.email}</td>
                    <td>{applicant.id}</td>
                  </tr>
                )) : (
                  <tr><td colSpan="4" className="text-center py-4">No users found.</td></tr>
                )}
              </tbody>
            </table>
          </div>
          {applicantData.length > studentItemsPerPage && (
            <Pagination className="justify-content-center mt-4 pagination-custom">
              <Pagination.Prev onClick={() => handleStudentPageChange(studentPage - 1)} disabled={studentPage === 1} />
              {Array.from({ length: totalStudentPages }, (_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === studentPage} onClick={() => handleStudentPageChange(i + 1)}>{i + 1}</Pagination.Item>
              ))}
              <Pagination.Next onClick={() => handleStudentPageChange(studentPage + 1)} disabled={studentPage === totalStudentPages} />
            </Pagination>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import { Modal, Pagination, Form } from "react-bootstrap"; // Added Form
// import { FaPlus, FaTrashAlt, FaSearch, FaUsers, FaCalendarPlus } from "react-icons/fa";
// import { FadeLoader } from "react-spinners";
// import Select from "react-select";

// // Custom Styles Component (Embedded CSS)
// const CustomStyles = () => (
//   <style>{`
//     body {
//       background-color: #f4f7f6;
//       font-family: 'Poppins', sans-serif;
//     }

//     .gradient-text {
//       background: linear-gradient(45deg, #007bff, #0056b3);
//       -webkit-background-clip: text;
//       -webkit-text-fill-color: transparent;
//       font-weight: 600;
//     }
    
//     .card-custom {
//       background-color: #ffffff;
//       border-radius: 15px;
//       padding: 30px;
//       box-shadow: 0 8px 25px rgba(0, 0, 0, 0.07);
//       transition: all 0.3s ease;
//     }
//     .card-custom:hover {
//       box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
//     }

//     .page-header {
//       font-size: 2.25rem;
//       margin-bottom: 25px;
//       color: #333;
//     }

//     .search-bar-custom .form-control {
//       border-radius: 25px;
//       padding-left: 40px;
//       border: 1px solid #ced4da;
//       transition: border-color 0.3s ease, box-shadow 0.3s ease;
//     }
//     .search-bar-custom .form-control:focus {
//       border-color: #007bff;
//       box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
//     }
//     .search-bar-custom .search-icon {
//       position: absolute;
//       left: 15px;
//       top: 50%;
//       transform: translateY(-50%);
//       color: #777;
//     }
    
//     .actions-container {
//       margin-bottom: 20px;
//       display: flex;
//       flex-wrap: wrap;
//       gap: 10px;
//     }

//     .btn-custom {
//       border-radius: 20px;
//       padding: 10px 20px;
//       font-size: 0.9rem;
//       font-weight: 500;
//       transition: all 0.3s ease;
//       display: flex;
//       align-items: center;
//       gap: 8px;
//     }
//     .btn-custom:hover {
//       transform: translateY(-2px);
//       box-shadow: 0 4px 10px rgba(0,0,0,0.1);
//     }
//     .btn-custom-success { background-color: #28a745; border-color: #28a745; color: white; }
//     .btn-custom-success:hover { background-color: #218838; border-color: #1e7e34; color: white; }
//     .btn-custom-primary { background-color: #007bff; border-color: #007bff; color: white; }
//     .btn-custom-primary:hover { background-color: #0069d9; border-color: #0062cc; color: white; }
    
//     .table-custom thead th {
//       background-color: #f8f9fa;
//       color: #333;
//       font-weight: 600;
//       border-bottom-width: 2px;
//       text-align: left;
//     }
//     .table-custom tbody tr { transition: background-color 0.2s ease; }
//     .table-custom tbody tr:hover { background-color: #e9ecef; }
//     .table-custom td, .table-custom th { padding: 12px 15px; vertical-align: middle; }

//     .spinner-container-page {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       height: 300px;
//     }
    
//     .pagination-custom .page-item.active .page-link { background-color: #007bff; border-color: #007bff; color: white; }
//     .pagination-custom .page-link { color: #007bff; border-radius: 0.25rem; margin: 0 2px; }
//     .pagination-custom .page-link:hover { background-color: #e9ecef; }
//     .pagination-custom .page-item.disabled .page-link { color: #6c757d; }

//     .modal-custom .modal-header { background: linear-gradient(45deg, #007bff, #0056b3); color: white; border-bottom: none; }
//     .modal-custom .modal-header .btn-close { filter: invert(1) grayscale(100%) brightness(200%); }
//     .modal-custom .modal-title { font-weight: 500; }
//     .modal-custom .modal-body { padding: 25px; }
//     .modal-custom .form-label { font-weight: 500; margin-bottom: 0.3rem; color: #555; }
    
//     .select__control { border-radius: 8px !important; border: 1px solid #ced4da !important; box-shadow: none !important; }
//     .select__control:hover { border-color: #007bff !important; }
//     .select__control--is-focused { border-color: #007bff !important; box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important; }
//     .select__menu { border-radius: 8px !important; box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important; }
//     .select__option:hover { background-color: #007bff !important; color: white !important; }
//     .select__option--is-selected { background-color: #0069d9 !important; color: white !important; }

//     /*
//     =====================================================
//     --- Full Height Layout ---
//     =====================================================
//     */
//     .interview-schedule-page.wrapper {
//       display: flex;
//       height: calc(100vh - 60px); /* Adjust 60px to your DashNavbar's height */
//     }

//     .interview-schedule-page .main {
//       flex-grow: 1;
//       display: flex;
//       flex-direction: column;
//       overflow: hidden;
//       padding: 20px;
//       background-color: #f4f7f6;
//     }

//     .interview-schedule-page .container-fluid {
//       flex-grow: 1;
//       display: flex;
//       flex-direction: column;
//     }

//     .interview-schedule-page .card-custom {
//       flex-grow: 1; /* Allow the card to fill the container's height */
//       display: flex;
//       flex-direction: column; /* Stack children vertically */
//       overflow: hidden; /* Important: Prevents card from creating its own scrollbar */
//     }

//     .interview-schedule-page .table-responsive {
//       flex-grow: 1; /* This is the key: makes the table container expand */
//       overflow-y: auto; /* Adds a vertical scrollbar ONLY to the table */
//     }
//   `}</style>
// );

// const reactSelectStyles = {
//   control: (provided) => ({ ...provided, borderColor: '#ced4da', borderRadius: '8px', boxShadow: 'none', '&:hover': { borderColor: '#007bff' } }),
//   menu: (provided) => ({ ...provided, borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }),
//   option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? '#0069d9' : state.isFocused ? '#007bff' : 'white', color: state.isSelected || state.isFocused ? 'white' : 'black', '&:active': { backgroundColor: '#0056b3' } }),
// };

// export default function InterviewSchedule() {
//   const [isLoading, setIsLoading] = useState(false);
//   const [applicantData, setApplicantData] = useState([]);
//   const [interviewData, setInterviewData] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [showStudentListModal, setShowStudentListModal] = useState(false);
//   const [interoptions, setInteroptions] = useState([]);
//   const [formData, setFormData] = useState({
//     candidate: "", interviewer: "", additionalMembers: [], meetLink: "", date: "", time: "", candidateId: null,
//     jobTitle: "", mode: "Online", location: "", interviewer_contact_number: "",
//   });
//   const [jobTitleOptions, setJobTitleOptions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [interviewersData, setInterviewersData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredInterviewData, setFilteredInterviewData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [studentPage, setStudentPage] = useState(1);
  
//   // MODIFIED: Converted itemsPerPage to a state with a default of 10
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const studentItemsPerPage = 5;

//   const candidates = applicantData.sort((a, b) => (a.full_name || a.name || "").localeCompare(b.full_name || b.name || ""));
//   const candioptions = candidates.map((candidate) => ({ value: candidate.full_name || candidate.name, label: `${candidate.full_name || candidate.name} (ID: ${candidate.id})`, id: candidate.id }));

//   useEffect(() => {
//     setIsLoading(true);
//     const fetchAllData = async () => {
//       try {
//         const [applicantRes, interviewsRes, interviewersRes, jobApplicationsRes] = await Promise.all([
//           axios.get("https://raasbackend.vetrinahealthcare.com/students/"),
//           axios.get("https://raasbackend.vetrinahealthcare.com/interviews/"),
//           axios.get("https://raasbackend.vetrinahealthcare.com/get_interviewers/"),
//           axios.get("https://raasbackend.vetrinahealthcare.com/job_applications_for_letter/")
//         ]);

//         setApplicantData(applicantRes.data);
//         setInterviewData(interviewsRes.data);
//         setFilteredInterviewData(interviewsRes.data);

//         setInterviewersData(interviewersRes.data);
//         const interviewerOpts = interviewersRes.data.map((interviewer) => ({ value: interviewer.name, label: interviewer.name }));
//         setInteroptions(interviewerOpts);

//         if (jobApplicationsRes.data && Array.isArray(jobApplicationsRes.data)) {
//           const uniqueJobTitles = [...new Set(jobApplicationsRes.data.map(app => app.job_title).filter(title => title && title.trim() !== ""))].sort((a, b) => a.localeCompare(b));
//           const jobOpts = uniqueJobTitles.map(title => ({ value: title, label: title }));
//           setJobTitleOptions(jobOpts);
//         } else {
//           console.warn("Job applications data is not in expected format or is empty:", jobApplicationsRes.data);
//           setJobTitleOptions([]);
//         }
//       } catch (err) {
//         console.error("Error fetching initial data:", err);
//         Swal.fire({ icon: "error", title: "Failed to load data", text: "Could not fetch initial data. Please try refreshing the page." });
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchAllData();
//   }, []);

//   useEffect(() => {
//     if (!showModal) {
//       setFormData({
//         candidate: "", interviewer: "", additionalMembers: [], meetLink: "", date: "", time: "", candidateId: null,
//         jobTitle: "", mode: "Online", location: "", interviewer_contact_number: "",
//       });
//     }
//   }, [showModal]);

//   const handleInputChange = (name, selectedOption) => {
//     setFormData(prevFormData => ({
//       ...prevFormData,
//       [name]: selectedOption ? selectedOption.value : "",
//       candidateId: name === "candidate" && selectedOption ? selectedOption.id : prevFormData.candidateId,
//     }));
//   };

//   const datehandleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleAddMember = () => setFormData({ ...formData, additionalMembers: [...formData.additionalMembers, ""] });

//   const handleRemoveMember = (index) => {
//     const updatedMembers = formData.additionalMembers.filter((_, i) => i !== index);
//     setFormData({ ...formData, additionalMembers: updatedMembers });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       if (!formData.candidate || !formData.interviewer || !formData.date || !formData.time) {
//         Swal.fire({ icon: "warning", title: "Missing Information", text: "Please fill in Candidate, Interviewer, Date, and Time.", timer: 3000, timerProgressBar: true, showConfirmButton: false });
//         setLoading(false);
//         return;
//       }

//       const selectedInterviewer = interviewersData.find((interviewer) => interviewer.name === formData.interviewer);
//       const selectedCandidateOption = candioptions.find((option) => option.value === formData.candidate);
//       if (!selectedInterviewer) throw new Error("Selected interviewer details not found.");
//       if (!selectedCandidateOption) throw new Error("Selected candidate details not found.");
      
//       const fullSelectedCandidate = applicantData.find((c) => c.id === selectedCandidateOption.id);
//       if (!fullSelectedCandidate || !fullSelectedCandidate.email) throw new Error("Selected candidate email not found.");
      
//       const dataToSend = {
//         candidate: formData.candidate, interviewer: formData.interviewer,
//         additionalMembers: formData.additionalMembers.filter(name => name && name.trim() !== ""),
//         meetLink: formData.meetLink, date: formData.date, time: formData.time,
//         candidateEmail: fullSelectedCandidate.email, interviewerEmail: selectedInterviewer.email,
//         candidateId: selectedCandidateOption.id, jobTitle: formData.jobTitle,
//         mode: formData.mode, location: formData.location, interviewer_contact_number: formData.interviewer_contact_number,
//       };

//       await axios.post("https://raasbackend.vetrinahealthcare.com/schedule-interview/", dataToSend);
//       const res = await axios.get("https://raasbackend.vetrinahealthcare.com/interviews/");
//       setInterviewData(res.data);
//       setShowModal(false);
//       Swal.fire({ icon: "success", title: "Interview Scheduled!", text: "The interview has been scheduled successfully.", timer: 2000, timerProgressBar: true, showConfirmButton: false });
//     } catch (error) {
//       console.error("Error scheduling interview:", error.response ? error.response.data : error.message);
//       Swal.fire({ icon: "error", title: "Oops...", text: (error.response?.data?.error) || "Something went wrong! Please try again later." });
//     } finally {
//       setLoading(false);
//     }
//   };

//   function formatTime(time) {
//     if (!time) return "N/A";
//     const [hoursStr, minutesStr] = time.split(":");
//     let hours = parseInt(hoursStr, 10);
//     const minutes = parseInt(minutesStr, 10);
//     if (isNaN(hours) || isNaN(minutes)) return "Invalid Time";
//     const period = hours >= 12 ? "PM" : "AM";
//     const formattedHours = hours % 12 || 12;
//     return `${formattedHours}:${String(minutes).padStart(2, "0")} ${period}`;
//   }

//   const toggleStudentListModal = () => setShowStudentListModal(!showStudentListModal);

//   useEffect(() => {
//     const filtered = interviewData.filter((interview) => {
//       const query = searchQuery.toLowerCase();
//       return (
//         interview.candidate?.toLowerCase().includes(query) ||
//         interview.interviewer?.toLowerCase().includes(query) ||
//         interview.job_title?.toLowerCase().includes(query) ||
//         (interview.date && new Date(interview.date).toLocaleDateString().toLowerCase().includes(query)) ||
//         interview.date?.toLowerCase().includes(query)
//       );
//     });
//     setFilteredInterviewData(filtered);
//     setCurrentPage(1);
//   }, [interviewData, searchQuery]);

//   // NEW: Handler for changing items per page
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1); // Reset to first page
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredInterviewData.slice(indexOfFirstItem, indexOfLastItem);
//   const studentIndexOfLastItem = studentPage * studentItemsPerPage;
//   const studentIndexOfFirstItem = studentIndexOfLastItem - studentItemsPerPage;
//   const currentStudentItems = applicantData.slice(studentIndexOfFirstItem, studentIndexOfLastItem);

//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
//   const handleStudentPageChange = (pageNumber) => setStudentPage(pageNumber);

//   const totalPages = Math.ceil(filteredInterviewData.length / itemsPerPage);
//   const totalStudentPages = Math.ceil(applicantData.length / studentItemsPerPage);

//   return (
//     <>
//       <CustomStyles />
//       <DashNavbar />
//       <div className="wrapper interview-schedule-page">
//         <Sidebar />
//         <main className="main">
//           <div className="container-fluid mt-3">
//             <div className="card-custom">
//               <h1 className="page-header gradient-text mb-4">Interview Schedule</h1>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <div className="search-bar-custom position-relative">
//                     <FaSearch className="search-icon" />
//                     <input type="search" className="form-control" placeholder="Search by candidate, interviewer, job title, or date..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//                   </div>
//                 </div>
//                 <div className="col-md-6 d-flex justify-content-md-end align-items-center mt-3 mt-md-0">
//                   <div className="actions-container">
//                     <button className="btn btn-custom btn-custom-success" onClick={() => setShowModal(true)}><FaCalendarPlus /> Schedule Interview</button>
//                     <button className="btn btn-custom btn-custom-primary" onClick={toggleStudentListModal}><FaUsers /> View Users</button>
//                   </div>
//                 </div>
//               </div>
//               {isLoading ? (
//                 <div className="spinner-container-page"><FadeLoader color="#007bff" loading={isLoading} size={150} /></div>
//               ) : (
//                 <>
//                   <div className="table-responsive">
//                     <table className="table table-custom table-hover table-striped">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Candidate</th>
//                           <th>Candidate ID</th>
//                           <th>Interviewer</th>
//                           <th>Job Title</th>
//                           <th>Date</th>
//                           <th>Time</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentItems.length > 0 ? currentItems.map((interview, index) => (
//                           <tr key={interview.id || index}>
//                             <td>{indexOfFirstItem + index + 1}</td>
//                             <td>{interview.candidate}</td>
//                             <td>{interview.candidate_id || "N/A"}</td>
//                             <td>{interview.interviewer}</td>
//                             <td>{interview.jobTitle || "N/A"}</td>
//                             <td>{interview.date ? new Date(interview.date).toLocaleDateString() : "N/A"}</td>
//                             <td>{formatTime(interview.time)}</td>
//                           </tr>
//                         )) : (
//                           <tr><td colSpan="7" className="text-center py-4">No interviews found.</td></tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>

//                   {/* MODIFIED: Pagination and View Options Wrapper */}
//                   {filteredInterviewData.length > 0 && (
//                      <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
//                         {/* NEW: Items per page selector */}
//                         <div className="d-flex align-items-center">
//                             <span className="me-2 small text-muted">Show</span>
//                             <Form.Select size="sm" style={{ width: 'auto' }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                 <option value="10">10</option>
//                                 <option value="25">25</option>
//                                 <option value="50">50</option>
//                             </Form.Select>
//                             <span className="ms-2 small text-muted">entries</span>
//                         </div>

//                         {/* Pagination controls */}
//                         {totalPages > 1 && (
//                             <Pagination className="pagination-custom mb-0">
//                                 <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                 {Array.from({ length: totalPages }, (_, i) => (
//                                     <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => handlePageChange(i + 1)}>{i + 1}</Pagination.Item>
//                                 ))}
//                                 <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                             </Pagination>
//                         )}
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </main>
//       </div>

//       {/* --- Modals --- */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} centered dialogClassName="modal-custom" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100">
//             Schedule New Interview
//             {loading && <FadeLoader color="#ffffff" loading={loading} css={{ display: 'inline-block', marginLeft: '15px', verticalAlign: 'middle' }} height={20} width={3} radius={2} margin={2} />}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <form onSubmit={handleSubmit}>
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Candidate:</label>
//                 <Select styles={reactSelectStyles} options={candioptions} value={candioptions.find(o => o.value === formData.candidate)} onChange={(val) => handleInputChange("candidate", val)} placeholder="Select Candidate..." isSearchable={true} />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Interviewer:</label>
//                 <Select styles={reactSelectStyles} options={interoptions} value={interoptions.find(o => o.value === formData.interviewer)} onChange={(val) => handleInputChange("interviewer", val)} placeholder="Select Interviewer..." isSearchable={true} />
//               </div>
//             </div>
//             <div className="mb-3">
//               <label className="form-label">Job Title :</label>
//               <Select styles={reactSelectStyles} options={jobTitleOptions} value={jobTitleOptions.find(o => o.value === formData.jobTitle)} onChange={(val) => handleInputChange("jobTitle", val)} placeholder="Select Job Title..." isSearchable={true} isClearable={true} />
//             </div>
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Mode:</label>
//                 <Select styles={reactSelectStyles} options={[{ value: 'Online', label: 'Online' }, { value: 'Offline', label: 'Offline (In-Person)' }]} value={{ value: formData.mode, label: formData.mode === 'Offline' ? 'Offline (In-Person)' : 'Online' }} onChange={(val) => handleInputChange("mode", val)} />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Interviewer Contact (Optional):</label>
//                 <input type="text" className="form-control" name="interviewer_contact_number" value={formData.interviewer_contact_number} onChange={datehandleInputChange} placeholder="e.g., +91 9876543210" />
//               </div>
//             </div>
//             {formData.mode === 'Online' ? (
//               <div className="mb-3">
//                 <label className="form-label">Meeting Link:</label>
//                 <input type="url" className="form-control" name="meetLink" value={formData.meetLink} onChange={datehandleInputChange} placeholder="https://meet.example.com/abc-def-ghi" required />
//               </div>
//             ) : (
//               <div className="mb-3">
//                 <label className="form-label">Location / Address:</label>
//                 <input type="text" className="form-control" name="location" value={formData.location} onChange={datehandleInputChange} placeholder="e.g., Office Building, 2nd Floor, City" required />
//               </div>
//             )}
//             <div className="mb-3">
//               <label className="form-label">Additional Members:</label>
//               {formData.additionalMembers.map((member, index) => (
//                 <div key={index} className="d-flex align-items-center mb-2">
//                   <Select styles={reactSelectStyles} options={applicantData.filter(app => { const appName = app.full_name || app.name; return appName !== formData.candidate && appName !== formData.interviewer; }).map((applicant) => ({ value: applicant.full_name || applicant.name, label: applicant.full_name || applicant.name }))} value={member ? { value: member, label: member } : null}
//                     onChange={(selectedOption) => {
//                       const updatedMembers = [...formData.additionalMembers];
//                       updatedMembers[index] = selectedOption ? selectedOption.value : "";
//                       setFormData({ ...formData, additionalMembers: updatedMembers });
//                     }}
//                     placeholder="Select Member..." isSearchable={true} className="flex-grow-1" />
//                   <button type="button" className="btn btn-danger ms-2" onClick={() => handleRemoveMember(index)} style={{ height: 'calc(2.25rem + 2px)', lineHeight: '1' }}> <FaTrashAlt /> </button>
//                 </div>
//               ))}
//               <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleAddMember}><FaPlus /> Add Member</button>
//             </div>
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Date:</label>
//                 <input type="date" className="form-control" name="date" value={formData.date} onChange={datehandleInputChange} min={new Date().toISOString().split("T")[0]} />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Time:</label>
//                 <input type="time" className="form-control" name="time" value={formData.time} onChange={datehandleInputChange} />
//               </div>
//             </div>
//             <div className="d-grid">
//               <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
//                 {loading ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Scheduling...</>) : ("Schedule Interview")}
//               </button>
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>

//       <Modal show={showStudentListModal} onHide={toggleStudentListModal} centered dialogClassName="modal-custom" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>User List</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="table-responsive">
//             <table className="table table-custom table-hover table-striped">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Name</th>
//                   <th>Email</th>
//                   <th>Role</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentStudentItems.length > 0 ? currentStudentItems.map((applicant, index) => (
//                   <tr key={applicant.id || index}>
//                     <td>{studentIndexOfFirstItem + index + 1}</td>
//                     <td>{applicant.full_name || applicant.name}</td>
//                     <td>{applicant.email}</td>
//                     <td>{applicant.role || "N/A"}</td>
//                   </tr>
//                 )) : (
//                   <tr><td colSpan="4" className="text-center py-4">No users found.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//           {applicantData.length > studentItemsPerPage && (
//             <Pagination className="justify-content-center mt-4 pagination-custom">
//               <Pagination.Prev onClick={() => handleStudentPageChange(studentPage - 1)} disabled={studentPage === 1} />
//               {Array.from({ length: totalStudentPages }, (_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === studentPage} onClick={() => handleStudentPageChange(i + 1)}>{i + 1}</Pagination.Item>
//               ))}
//               <Pagination.Next onClick={() => handleStudentPageChange(studentPage + 1)} disabled={studentPage === totalStudentPages} />
//             </Pagination>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// }









// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Sidebar from "../Misc/Sidebar";
// import DashNavbar from "../Misc/DashNavbar";
// import { Modal, Pagination, Form } from "react-bootstrap";
// import { FaPlus, FaTrashAlt, FaSearch, FaUsers, FaCalendarPlus } from "react-icons/fa";
// import { FadeLoader } from "react-spinners";
// import Select from "react-select";

// // Custom Styles Component (Embedded CSS)
// const CustomStyles = () => (
//   <style>{`
//     body {
//       background-color: #f4f7f6;
//       font-family: 'Poppins', sans-serif;
//     }

//     .gradient-text {
//       background: linear-gradient(45deg, #007bff, #0056b3);
//       -webkit-background-clip: text;
//       -webkit-text-fill-color: transparent;
//       font-weight: 600;
//     }
    
//     .card-custom {
//       background-color: #ffffff;
//       border-radius: 15px;
//       padding: 30px;
//       box-shadow: 0 8px 25px rgba(0, 0, 0, 0.07);
//       transition: all 0.3s ease;
//     }
//     .card-custom:hover {
//       box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
//     }

//     .page-header {
//       font-size: 2.25rem;
//       margin-bottom: 25px;
//       color: #333;
//     }

//     .search-bar-custom .form-control {
//       border-radius: 25px;
//       padding-left: 40px;
//       border: 1px solid #ced4da;
//       transition: border-color 0.3s ease, box-shadow 0.3s ease;
//     }
//     .search-bar-custom .form-control:focus {
//       border-color: #007bff;
//       box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
//     }
//     .search-bar-custom .search-icon {
//       position: absolute;
//       left: 15px;
//       top: 50%;
//       transform: translateY(-50%);
//       color: #777;
//     }
    
//     .actions-container {
//       margin-bottom: 20px;
//       display: flex;
//       flex-wrap: wrap;
//       gap: 10px;
//     }

//     .btn-custom {
//       border-radius: 20px;
//       padding: 10px 20px;
//       font-size: 0.9rem;
//       font-weight: 500;
//       transition: all 0.3s ease;
//       display: flex;
//       align-items: center;
//       gap: 8px;
//     }
//     .btn-custom:hover {
//       transform: translateY(-2px);
//       box-shadow: 0 4px 10px rgba(0,0,0,0.1);
//     }
//     .btn-custom-success { background-color: #28a745; border-color: #28a745; color: white; }
//     .btn-custom-success:hover { background-color: #218838; border-color: #1e7e34; color: white; }
//     .btn-custom-primary { background-color: #007bff; border-color: #007bff; color: white; }
//     .btn-custom-primary:hover { background-color: #0069d9; border-color: #0062cc; color: white; }
    
//     .table-custom thead th {
//       background-color: #f8f9fa;
//       color: #333;
//       font-weight: 600;
//       border-bottom-width: 2px;
//       text-align: left;
//     }
//     .table-custom tbody tr { transition: background-color 0.2s ease; }
//     .table-custom tbody tr:hover { background-color: #e9ecef; }
//     .table-custom td, .table-custom th { padding: 12px 15px; vertical-align: middle; }

//     .spinner-container-page {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       height: 300px;
//     }
    
//     .pagination-custom .page-item.active .page-link { background-color: #007bff; border-color: #007bff; color: white; }
//     .pagination-custom .page-link { color: #007bff; border-radius: 0.25rem; margin: 0 2px; }
//     .pagination-custom .page-link:hover { background-color: #e9ecef; }
//     .pagination-custom .page-item.disabled .page-link { color: #6c757d; }

//     .modal-custom .modal-header { background: linear-gradient(45deg, #007bff, #0056b3); color: white; border-bottom: none; }
//     .modal-custom .modal-header .btn-close { filter: invert(1) grayscale(100%) brightness(200%); }
//     .modal-custom .modal-title { font-weight: 500; }
//     .modal-custom .modal-body { padding: 25px; }
//     .modal-custom .form-label { font-weight: 500; margin-bottom: 0.3rem; color: #555; }
    
//     .select__control { border-radius: 8px !important; border: 1px solid #ced4da !important; box-shadow: none !important; }
//     .select__control:hover { border-color: #007bff !important; }
//     .select__control--is-focused { border-color: #007bff !important; box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important; }
//     .select__menu { border-radius: 8px !important; box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important; }
//     .select__option:hover { background-color: #007bff !important; color: white !important; }
//     .select__option--is-selected { background-color: #0069d9 !important; color: white !important; }

//     .interview-schedule-page.wrapper {
//       display: flex;
//       height: calc(100vh - 60px);
//     }

//     .interview-schedule-page .main {
//       flex-grow: 1;
//       display: flex;
//       flex-direction: column;
//       overflow: hidden;
//       padding: 20px;
//       background-color: #f4f7f6;
//     }

//     .interview-schedule-page .container-fluid {
//       flex-grow: 1;
//       display: flex;
//       flex-direction: column;
//     }

//     .interview-schedule-page .card-custom {
//       flex-grow: 1;
//       display: flex;
//       flex-direction: column;
//       overflow: hidden;
//     }

//     .interview-schedule-page .table-responsive {
//       flex-grow: 1;
//       overflow-y: auto;
//     }
//   `}</style>
// );

// const reactSelectStyles = {
//   control: (provided) => ({ ...provided, borderColor: '#ced4da', borderRadius: '8px', boxShadow: 'none', '&:hover': { borderColor: '#007bff' } }),
//   menu: (provided) => ({ ...provided, borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }),
//   option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? '#0069d9' : state.isFocused ? '#007bff' : 'white', color: state.isSelected || state.isFocused ? 'white' : 'black', '&:active': { backgroundColor: '#0056b3' } }),
// };

// export default function InterviewSchedule() {
//   const [isLoading, setIsLoading] = useState(false);
//   const [applicantData, setApplicantData] = useState([]);
//   const [interviewData, setInterviewData] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [showStudentListModal, setShowStudentListModal] = useState(false);
//   const [interoptions, setInteroptions] = useState([]);
//   const [formData, setFormData] = useState({
//     candidate: "", interviewer: "", additionalMembers: [], meetLink: "", date: "", time: "", candidateId: null,
//     jobTitle: "", mode: "Online", location: "", interviewer_contact_number: "", opening_post: ""
//   });
//   const [jobTitleOptions, setJobTitleOptions] = useState([]);
//   const [openingPostOptions, setOpeningPostOptions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [interviewersData, setInterviewersData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredInterviewData, setFilteredInterviewData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [studentPage, setStudentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const studentItemsPerPage = 5;

//   const candidates = applicantData.sort((a, b) => (a.full_name || a.name || "").localeCompare(b.full_name || b.name || ""));
//   const candioptions = candidates.map((candidate) => ({ value: candidate.full_name || candidate.name, label: `${candidate.full_name || candidate.name} (ID: ${candidate.id})`, id: candidate.id }));

//   useEffect(() => {
//     setIsLoading(true);
//     const fetchAllData = async () => {
//       try {
//         const [applicantRes, interviewsRes, interviewersRes, jobApplicationsRes] = await Promise.all([
//           axios.get("https://raasbackend.vetrinahealthcare.com/students/"),
//           axios.get("https://raasbackend.vetrinahealthcare.com/interviews/"),
//           axios.get("https://raasbackend.vetrinahealthcare.com/get_interviewers/"),
//           axios.get("https://raasbackend.vetrinahealthcare.com/job_applications_for_letter/")
//         ]);

//         setApplicantData(applicantRes.data);
//         setInterviewData(interviewsRes.data);
//         setFilteredInterviewData(interviewsRes.data);

//         setInterviewersData(interviewersRes.data);
//         const interviewerOpts = interviewersRes.data.map((interviewer) => ({ value: interviewer.name, label: interviewer.name }));
//         setInteroptions(interviewerOpts);

//         // Dummy data for opening post options as API is not provided
//         const postOptions = [
//             { value: 'Business_Opportunity', label: 'Business Opportunity' },
//             { value: 'Full_Time', label: 'Full Time' },
//             { value: 'Part_Time', label: 'Part Time' },
//             { value: 'Internship', label: 'Internship' }
//         ];
//         setOpeningPostOptions(postOptions);

//         if (jobApplicationsRes.data && Array.isArray(jobApplicationsRes.data)) {
//           const uniqueJobTitles = [...new Set(jobApplicationsRes.data.map(app => app.job_title).filter(title => title && title.trim() !== ""))].sort((a, b) => a.localeCompare(b));
//           const jobOpts = uniqueJobTitles.map(title => ({ value: title, label: title }));
//           setJobTitleOptions(jobOpts);
//         } else {
//           console.warn("Job applications data is not in expected format or is empty:", jobApplicationsRes.data);
//           setJobTitleOptions([]);
//         }
//       } catch (err) {
//         console.error("Error fetching initial data:", err);
//         Swal.fire({ icon: "error", title: "Failed to load data", text: "Could not fetch initial data. Please try refreshing the page." });
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchAllData();
//   }, []);

//   useEffect(() => {
//     if (!showModal) {
//       setFormData({
//         candidate: "", interviewer: "", additionalMembers: [], meetLink: "", date: "", time: "", candidateId: null,
//         jobTitle: "", mode: "Online", location: "", interviewer_contact_number: "", opening_post: ""
//       });
//     }
//   }, [showModal]);

//   const handleInputChange = (name, selectedOption) => {
//     setFormData(prevFormData => ({
//       ...prevFormData,
//       [name]: selectedOption ? selectedOption.value : "",
//       candidateId: name === "candidate" && selectedOption ? selectedOption.id : prevFormData.candidateId,
//     }));
//   };

//   const datehandleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleAddMember = () => setFormData({ ...formData, additionalMembers: [...formData.additionalMembers, ""] });

//   const handleRemoveMember = (index) => {
//     const updatedMembers = formData.additionalMembers.filter((_, i) => i !== index);
//     setFormData({ ...formData, additionalMembers: updatedMembers });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       if (!formData.candidate || !formData.interviewer || !formData.date || !formData.time) {
//         Swal.fire({ icon: "warning", title: "Missing Information", text: "Please fill in Candidate, Interviewer, Date, and Time.", timer: 3000, timerProgressBar: true, showConfirmButton: false });
//         setLoading(false);
//         return;
//       }

//       const selectedInterviewer = interviewersData.find((interviewer) => interviewer.name === formData.interviewer);
//       const selectedCandidateOption = candioptions.find((option) => option.value === formData.candidate);
//       if (!selectedInterviewer) throw new Error("Selected interviewer details not found.");
//       if (!selectedCandidateOption) throw new Error("Selected candidate details not found.");
      
//       const fullSelectedCandidate = applicantData.find((c) => c.id === selectedCandidateOption.id);
//       if (!fullSelectedCandidate || !fullSelectedCandidate.email) throw new Error("Selected candidate email not found.");
      
//       const dataToSend = {
//         candidate: formData.candidate,
//         interviewer: formData.interviewer,
//         additionalMembers: formData.additionalMembers.filter(name => name && name.trim() !== ""),
//         meetLink: formData.meetLink,
//         date: formData.date,
//         time: formData.time,
//         candidateEmail: fullSelectedCandidate.email,
//         interviewerEmail: selectedInterviewer.email,
//         candidateId: selectedCandidateOption.id,
//         jobTitle: formData.jobTitle,
//         mode: formData.mode,
//         location: formData.location,
//         interviewer_contact_number: formData.interviewer_contact_number,
//         opening_post: formData.opening_post
//       };

//       await axios.post("https://raasbackend.vetrinahealthcare.com/schedule-interview/", dataToSend);
//       const res = await axios.get("https://raasbackend.vetrinahealthcare.com/interviews/");
//       setInterviewData(res.data);
//       setShowModal(false);
//       Swal.fire({ icon: "success", title: "Interview Scheduled!", text: "The interview has been scheduled successfully.", timer: 2000, timerProgressBar: true, showConfirmButton: false });
//     } catch (error) {
//       console.error("Error scheduling interview:", error.response ? error.response.data : error.message);
//       Swal.fire({ icon: "error", title: "Oops...", text: (error.response?.data?.error) || "Something went wrong! Please try again later." });
//     } finally {
//       setLoading(false);
//     }
//   };

//   function formatTime(time) {
//     if (!time) return "N/A";
//     const [hoursStr, minutesStr] = time.split(":");
//     let hours = parseInt(hoursStr, 10);
//     const minutes = parseInt(minutesStr, 10);
//     if (isNaN(hours) || isNaN(minutes)) return "Invalid Time";
//     const period = hours >= 12 ? "PM" : "AM";
//     const formattedHours = hours % 12 || 12;
//     return `${formattedHours}:${String(minutes).padStart(2, "0")} ${period}`;
//   }

//   const toggleStudentListModal = () => setShowStudentListModal(!showStudentListModal);

//   useEffect(() => {
//     const filtered = interviewData.filter((interview) => {
//       const query = searchQuery.toLowerCase();
//       return (
//         interview.candidate?.toLowerCase().includes(query) ||
//         interview.interviewer?.toLowerCase().includes(query) ||
//         interview.job_title?.toLowerCase().includes(query) ||
//         interview.opening_post?.toLowerCase().includes(query) ||
//         (interview.date && new Date(interview.date).toLocaleDateString().toLowerCase().includes(query)) ||
//         interview.date?.toLowerCase().includes(query)
//       );
//     });
//     setFilteredInterviewData(filtered);
//     setCurrentPage(1);
//   }, [interviewData, searchQuery]);

//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredInterviewData.slice(indexOfFirstItem, indexOfLastItem);
//   const studentIndexOfLastItem = studentPage * studentItemsPerPage;
//   const studentIndexOfFirstItem = studentIndexOfLastItem - studentItemsPerPage;
//   const currentStudentItems = applicantData.slice(studentIndexOfFirstItem, studentIndexOfLastItem);

//   const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
//   const handleStudentPageChange = (pageNumber) => setStudentPage(pageNumber);

//   const totalPages = Math.ceil(filteredInterviewData.length / itemsPerPage);
//   const totalStudentPages = Math.ceil(applicantData.length / studentItemsPerPage);

//   return (
//     <>
//       <CustomStyles />
//       <DashNavbar />
//       <div className="wrapper interview-schedule-page">
//         <Sidebar />
//         <main className="main">
//           <div className="container-fluid mt-3">
//             <div className="card-custom">
//               <h1 className="page-header gradient-text mb-4">Interview Schedule</h1>
//               <div className="row mb-3">
//                 <div className="col-md-6">
//                   <div className="search-bar-custom position-relative">
//                     <FaSearch className="search-icon" />
//                     <input type="search" className="form-control" placeholder="Search by candidate, interviewer, job title, or date..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//                   </div>
//                 </div>
//                 <div className="col-md-6 d-flex justify-content-md-end align-items-center mt-3 mt-md-0">
//                   <div className="actions-container">
//                     <button className="btn btn-custom btn-custom-success" onClick={() => setShowModal(true)}><FaCalendarPlus /> Schedule Interview</button>
//                     <button className="btn btn-custom btn-custom-primary" onClick={toggleStudentListModal}><FaUsers /> View Users</button>
//                   </div>
//                 </div>
//               </div>
//               {isLoading ? (
//                 <div className="spinner-container-page"><FadeLoader color="#007bff" loading={isLoading} size={150} /></div>
//               ) : (
//                 <>
//                   <div className="table-responsive">
//                     <table className="table table-custom table-hover table-striped">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Candidate</th>
//                           <th>Candidate ID</th>
//                           <th>Interviewer</th>
//                           <th>Job Title</th>
//                           <th>Opening Post</th>
//                           <th>Date</th>
//                           <th>Time</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentItems.length > 0 ? currentItems.map((interview, index) => (
//                           <tr key={interview.id || index}>
//                             <td>{indexOfFirstItem + index + 1}</td>
//                             <td>{interview.candidate}</td>
//                             <td>{interview.candidate_id || "N/A"}</td>
//                             <td>{interview.interviewer}</td>
//                             <td>{interview.jobTitle || "N/A"}</td>
//                             <td>{interview.opening_post || "N/A"}</td>
//                             <td>{interview.date ? new Date(interview.date).toLocaleDateString() : "N/A"}</td>
//                             <td>{formatTime(interview.time)}</td>
//                           </tr>
//                         )) : (
//                           <tr><td colSpan="8" className="text-center py-4">No interviews found.</td></tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>

//                   {filteredInterviewData.length > 0 && (
//                      <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
//                         <div className="d-flex align-items-center">
//                             <span className="me-2 small text-muted">Show</span>
//                             <Form.Select size="sm" style={{ width: 'auto' }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                                 <option value="10">10</option>
//                                 <option value="25">25</option>
//                                 <option value="50">50</option>
//                             </Form.Select>
//                             <span className="ms-2 small text-muted">entries</span>
//                         </div>

//                         {totalPages > 1 && (
//                             <Pagination className="pagination-custom mb-0">
//                                 <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                                 {Array.from({ length: totalPages }, (_, i) => (
//                                     <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => handlePageChange(i + 1)}>{i + 1}</Pagination.Item>
//                                 ))}
//                                 <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                             </Pagination>
//                         )}
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </main>
//       </div>

//       <Modal show={showModal} onHide={() => setShowModal(false)} centered dialogClassName="modal-custom" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100">
//             Schedule New Interview
//             {loading && <FadeLoader color="#ffffff" loading={loading} css={{ display: 'inline-block', marginLeft: '15px', verticalAlign: 'middle' }} height={20} width={3} radius={2} margin={2} />}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <form onSubmit={handleSubmit}>
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Candidate:</label>
//                 <Select styles={reactSelectStyles} options={candioptions} value={candioptions.find(o => o.value === formData.candidate)} onChange={(val) => handleInputChange("candidate", val)} placeholder="Select Candidate..." isSearchable={true} />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Interviewer:</label>
//                 <Select styles={reactSelectStyles} options={interoptions} value={interoptions.find(o => o.value === formData.interviewer)} onChange={(val) => handleInputChange("interviewer", val)} placeholder="Select Interviewer..." isSearchable={true} />
//               </div>
//             </div>
//             <div className="mb-3">
//               <label className="form-label">Job Title:</label>
//               <Select styles={reactSelectStyles} options={jobTitleOptions} value={jobTitleOptions.find(o => o.value === formData.jobTitle)} onChange={(val) => handleInputChange("jobTitle", val)} placeholder="Select Job Title..." isSearchable={true} isClearable={true} />
//             </div>
//             <div className="mb-3">
//               <label className="form-label">Opening Post:</label>
//               <Select styles={reactSelectStyles} options={openingPostOptions} value={openingPostOptions.find(o => o.value === formData.opening_post)} onChange={(val) => handleInputChange("opening_post", val)} placeholder="Select Opening Post..." isSearchable={true} isClearable={true} />
//             </div>
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Mode:</label>
//                 <Select styles={reactSelectStyles} options={[{ value: 'Online', label: 'Online' }, { value: 'Offline', label: 'Offline (In-Person)' }]} value={{ value: formData.mode, label: formData.mode === 'Offline' ? 'Offline (In-Person)' : 'Online' }} onChange={(val) => handleInputChange("mode", val)} />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Interviewer Contact (Optional):</label>
//                 <input type="text" className="form-control" name="interviewer_contact_number" value={formData.interviewer_contact_number} onChange={datehandleInputChange} placeholder="e.g., +91 9876543210" />
//               </div>
//             </div>
//             {formData.mode === 'Online' ? (
//               <div className="mb-3">
//                 <label className="form-label">Meeting Link:</label>
//                 <input type="url" className="form-control" name="meetLink" value={formData.meetLink} onChange={datehandleInputChange} placeholder="https://meet.example.com/abc-def-ghi" required />
//               </div>
//             ) : (
//               <div className="mb-3">
//                 <label className="form-label">Location / Address:</label>
//                 <input type="text" className="form-control" name="location" value={formData.location} onChange={datehandleInputChange} placeholder="e.g., Office Building, 2nd Floor, City" required />
//               </div>
//             )}
//             <div className="mb-3">
//               <label className="form-label">Additional Members:</label>
//               {formData.additionalMembers.map((member, index) => (
//                 <div key={index} className="d-flex align-items-center mb-2">
//                   <Select styles={reactSelectStyles} options={applicantData.filter(app => { const appName = app.full_name || app.name; return appName !== formData.candidate && appName !== formData.interviewer; }).map((applicant) => ({ value: applicant.full_name || applicant.name, label: applicant.full_name || applicant.name }))} value={member ? { value: member, label: member } : null}
//                     onChange={(selectedOption) => {
//                       const updatedMembers = [...formData.additionalMembers];
//                       updatedMembers[index] = selectedOption ? selectedOption.value : "";
//                       setFormData({ ...formData, additionalMembers: updatedMembers });
//                     }}
//                     placeholder="Select Member..." isSearchable={true} className="flex-grow-1" />
//                   <button type="button" className="btn btn-danger ms-2" onClick={() => handleRemoveMember(index)} style={{ height: 'calc(2.25rem + 2px)', lineHeight: '1' }}> <FaTrashAlt /> </button>
//                 </div>
//               ))}
//               <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleAddMember}><FaPlus /> Add Member</button>
//             </div>
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Date:</label>
//                 <input type="date" className="form-control" name="date" value={formData.date} onChange={datehandleInputChange} min={new Date().toISOString().split("T")[0]} />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Time:</label>
//                 <input type="time" className="form-control" name="time" value={formData.time} onChange={datehandleInputChange} />
//               </div>
//             </div>
//             <div className="d-grid">
//               <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
//                 {loading ? (<><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Scheduling...</>) : ("Schedule Interview")}
//               </button>
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>

//       <Modal show={showStudentListModal} onHide={toggleStudentListModal} centered dialogClassName="modal-custom" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>User List</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="table-responsive">
//             <table className="table table-custom table-hover table-striped">
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Name</th>
//                   <th>Email</th>
//                   <th>Role</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentStudentItems.length > 0 ? currentStudentItems.map((applicant, index) => (
//                   <tr key={applicant.id || index}>
//                     <td>{studentIndexOfFirstItem + index + 1}</td>
//                     <td>{applicant.full_name || applicant.name}</td>
//                     <td>{applicant.email}</td>
//                     <td>{applicant.role || "N/A"}</td>
//                   </tr>
//                 )) : (
//                   <tr><td colSpan="4" className="text-center py-4">No users found.</td></tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//           {applicantData.length > studentItemsPerPage && (
//             <Pagination className="justify-content-center mt-4 pagination-custom">
//               <Pagination.Prev onClick={() => handleStudentPageChange(studentPage - 1)} disabled={studentPage === 1} />
//               {Array.from({ length: totalStudentPages }, (_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === studentPage} onClick={() => handleStudentPageChange(i + 1)}>{i + 1}</Pagination.Item>
//               ))}
//               <Pagination.Next onClick={() => handleStudentPageChange(studentPage + 1)} disabled={studentPage === totalStudentPages} />
//             </Pagination>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// }